export enum LIGHT_MODES {
  DAY = "day",
  SUNSET = "sunset",
  NIGHT = "night",
}
export enum LED {
  ORANGE = "orange",
  BLUE = "blue",
  RED = "red",
}
export const LOCALES = ["en"]; /* "de" */
export const STREAM_ID = "stream-container";
export const STREAM_DEFAULT_SETTINGS = {
  initialSettings: {
    AutoConnect: true,
    StartVideoMuted: true,
    XRControllerInput: false,
    GamepadInput: false,
  },
  settings: {
    fullscreenButton: true,
    infoButton: false,
    micButton: false,
    audioButton: false,
    settingsButton: false,
    connectionStrengthIcon: false,
  },
};
export const FRAME_BORDER_WIDTH: Record<"xs" | "lg" | "xxxl", number> = {
  xs: 1,
  lg: 2,
  xxxl: 5,
};

export const DRAWER_PICK_AREA_HEIGHT = 38;
// export const DRAWER_PICK_HEIGHT_COLLAPSED = 24;
export const DRAWER_PICK_HEIGHT_COLLAPSED = 0;

/* 'md' is by default */
export const BREAKPOINT_MOBILE = "lg";
export const EMIT_NESTED_CATEGORIES = ["metallic", "unicolors"];
// export const VAT = 1.19 /* 19% */
export const VAT = 1; /* 19% */
